import React, { useEffect, useState, useRef } from 'react'
import Contacts from './Contacts'
// import ChatContainer from './ChatContainer'
import Welcome from './Welcome'
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Chat from './Chat'
import { io } from "socket.io-client";
import { RevolvingDot } from 'react-loader-spinner'
import { teleConsultationModel } from '../Axios/AxiosConfig'
import { getUserDetails } from '../Auth/AuthUtil'
import LoadingComponent from "../loading"
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight, ArrowBack } from '@mui/icons-material';
import './ChatPage.css'
import Cookies from 'js-cookie';

export default function ChatPage() {

    const navigate = useNavigate();
    const location = useLocation();
    const { fromProfile, hideContacts, patientData } = location.state || {};

    const doctorDetailsCookie = Cookies.get('Doctor_details');

    let Doctor_details = {};

    const [logoutOpen, setLogoutOpen] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    if (doctorDetailsCookie) {
        try {
            Doctor_details = JSON.parse(doctorDetailsCookie);
        } catch (error) {
            console.log('Error parsing Doctor_details cookie:', error);
        }
    }

    let [Contact, SetContacts] = useState([])

    const socket = useRef();

    let [loading, isloading] = useState(true)

    let [Onlineuser, setonline] = useState([])

    let [lastseen, setlastseen] = useState([])

    let [currentuser, setcurrentuser] = useState('')

    const [currentChat, setCurrentChat] = useState(undefined);

    const userdetails = getUserDetails()

    const [isSidebarVisible, setIsSidebarVisible] = useState(!hideContacts);


    let getdata = async () => {

        try {
            let res = await teleConsultationModel.post('AllPatients', {
                Doc_id: Doctor_details?.PID
            })

            if (res.status === 200) {
                SetContacts(res?.data?.data)
                isloading(false)
            }
        }
        catch (err) {
            console.log(err)
        }


    }

    useEffect(() => {
        getdata()
    }, [currentuser]);

    useEffect(() => {
        // If navigated from profile with patient data, auto-select that chat
        if (fromProfile && patientData) {
            setCurrentChat(patientData);
        }
    }, [fromProfile, patientData]);

    const handleChatChange = (chat) => {
        setCurrentChat(chat);
    };

    const handleBackToProfile = () => {
        if (currentChat?.patient_id || currentChat?._id) {
            const { patient_id, Appointment_id } = currentChat;
            navigate(`/Patient/${Appointment_id}`);
        }
    };

    return <>
        {
            loading ? <LoadingComponent loading={teleConsultationModel} /> :
                <div className='main'>
                    <div className="containes">
                        {/* {fromProfile && (
                            <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0' }}>
                                <IconButton onClick={handleBackToProfile}>
                                    <ArrowBack />
                                </IconButton>
                                <span style={{ marginLeft: '8px', fontSize: '16px', fontWeight: '500' }}>
                                    Back to Profile
                                </span>
                            </div>
                        )} */}
                        {!hideContacts && (
                            <div className={`sidebar-container ${isSidebarVisible ? 'visible' : 'hidden'}`}>
                                <Contacts Contacts={Contact} changeChat={handleChatChange} online={Onlineuser} />
                            </div>
                        )}
                        {!hideContacts && (
                            <IconButton
                                onClick={() => setIsSidebarVisible(!isSidebarVisible)}
                                className={`collapse-button ${isSidebarVisible ? 'visible' : 'hidden'}`}
                            >
                                {isSidebarVisible ? <ChevronLeft /> : <ChevronRight />}
                            </IconButton>
                        )}
                        <div className="chat-container-main">
                            {currentChat === undefined ? <Welcome /> :
                                <Chat currentChat={currentChat} socket={socket} online={Onlineuser} lastseen={lastseen} fromProfile={fromProfile} />}
                        </div>
                    </div>
                </div>
        }
    </>
}
